import React, { useState } from 'react';
import './ContactSection.css';
import instagramIcon from '../../assets/social-icons/instagram.svg';
import facebookIcon from '../../assets/social-icons/facebook.svg';
import youtubeIcon from '../../assets/social-icons/youtube.svg';
import tiktokIcon from '../../assets/social-icons/tiktok.svg';

/**
 * ContactSection - Sección de contacto reutilizable
 * Muestra información de contacto y opcionalmente un formulario
 */
const ContactSection = ({
  title,
  description,
  email,
  phone,
  address,
  social,
  showForm = false,
  theme = 'dark'
}) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí podrías integrar con un backend o servicio de email
    console.log('Form submitted:', formData);
    alert('Mensaje enviado! Te contactaremos pronto.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className={`contactContainer contactContainer--${theme}`} id="contact">
      {title && <h2 className="contactTitle">{title.toUpperCase()}</h2>}
      {description && <p className="contactDescription">{description}</p>}

      <div className="contactContent">
        {/* Información de contacto */}
        <div className="contactInfo">
          {email && (
            <div className="contactItem">
              <span className="contactLabel">EMAIL</span>
              <a href={`mailto:${email}`} className="contactValue">{email}</a>
            </div>
          )}
          {phone && (
            <div className="contactItem">
              <span className="contactLabel">TELÉFONO</span>
              <a href={`tel:${phone}`} className="contactValue">{phone}</a>
            </div>
          )}
          {address && (
            <div className="contactItem">
              <span className="contactLabel">DIRECCIÓN</span>
              <span className="contactValue">{address}</span>
            </div>
          )}
          {social && (
            <div className="contactSocial">
              {social.instagram && (
                <a
                  href={social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="socialLink"
                  aria-label="Instagram"
                >
                  <img src={instagramIcon} alt="Instagram" className="socialIcon" />
                </a>
              )}
              {social.facebook && (
                <a
                  href={social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="socialLink"
                  aria-label="Facebook"
                >
                  <img src={facebookIcon} alt="Facebook" className="socialIcon" />
                </a>
              )}
              {social.youtube && (
                <a
                  href={social.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="socialLink"
                  aria-label="YouTube"
                >
                  <img src={youtubeIcon} alt="YouTube" className="socialIcon" />
                </a>
              )}
              {social.tiktok && (
                <a
                  href={social.tiktok}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="socialLink"
                  aria-label="TikTok"
                >
                  <img src={tiktokIcon} alt="TikTok" className="socialIcon" />
                </a>
              )}
            </div>
          )}
        </div>

        {/* Formulario de contacto (opcional) */}
        {showForm && (
          <form className="contactForm" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Nombre"
              value={formData.name}
              onChange={handleChange}
              required
              className="formInput"
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
              className="formInput"
            />
            <input
              type="tel"
              name="phone"
              placeholder="Teléfono"
              value={formData.phone}
              onChange={handleChange}
              className="formInput"
            />
            <textarea
              name="message"
              placeholder="Mensaje"
              value={formData.message}
              onChange={handleChange}
              required
              rows="5"
              className="formTextarea"
            />
            <button type="submit" className={`formSubmit pillButton pillButton--on-${theme}`}>
              ENVIAR MENSAJE
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactSection;
